import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

export default function DeleteConfirmationDialog({
    open,
    title,
    message,
    onConfirm,
    onCancel
}) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent dividers>
                <Typography>{message}</Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button color="error" variant="contained" onClick={onConfirm}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
